module.exports = __webpack_public_path__ + "static/media/proteinfasta.c1e0eb63.fasta";